import { ProposalConsignadoCustomStatus } from "@/models/consignado/proposal.model";

export const proposalStatusLabels: { [key in ProposalStatusType]: string } = {
  PENDING_CONFIRMATION: "Aguardando Confirmação",
  PENDING_FORMALIZATION: "Aguardando Formalização",
  PENDING_REFORMALIZATION: "Aguardando Refazer Formalização",
  PENDING_BANK_ANALYSIS: "Aguardando Análise Banco",
  PENDING_PAYMENT: "Aguardando Pagamento",
  PENDING_USER_REVIEW: "Aguardando Revisão do Usuário",
  PAYED: "Pago",
  SELFSERVICE: "Autoatendimento",
  CANCELED: "Cancelado",
  REPROVED: "Reprovado",
  IN_CANCELLATION: "Cancelamento em andamento",
  CANCELED_BY_CLIENT: "Cancelado pelo cliente",
  ERROR_CREATE_BIOMETRIC_VALIDATION: "Falha no Link da Formalização",
};

export type ProposalStatusType =
  | "PENDING_CONFIRMATION"
  | "PENDING_FORMALIZATION"
  | "PENDING_REFORMALIZATION"
  | "PENDING_BANK_ANALYSIS"
  | "PENDING_PAYMENT"
  | "PENDING_USER_REVIEW"
  | "PAYED"
  | "SELFSERVICE"
  | "CANCELED"
  | "REPROVED"
  | "IN_CANCELLATION"
  | "CANCELED_BY_CLIENT"
  | "ERROR_CREATE_BIOMETRIC_VALIDATION";

export function getProposalConsignadoStatusLabel(status: ProposalStatusType): string {
  return proposalStatusLabels[status] || "Status Desconhecido";
}
function removeDatePrefix(message: string): string {
  // Remove prefix no formato "dd/MM/yy HH:mm: "
  const regex = /^\d{2}\/\d{2}\/\d{2} \d{2}:\d{2}:\s*/;
  return message.replace(regex, "");
}
export function getProposalStatusDescription(status?: ProposalStatusType, customStatus?: ProposalConsignadoCustomStatus | string): string {
  if (status == "CANCELED" && customStatus) {
    try {
      let parsedCustomStatus: ProposalConsignadoCustomStatus;

      if (typeof customStatus === "string") {
        parsedCustomStatus = JSON.parse(customStatus);
      } else {
        parsedCustomStatus = customStatus as ProposalConsignadoCustomStatus;
      }

      const cancelamentos = parsedCustomStatus?.cancelamento;
           
      if (cancelamentos && typeof cancelamentos === "object") {
        const cancelamentoKeys = [
          "cancelado_usuario",
          "bloqueio_saldo_negado",
          "reprovado_seg_identidade",
          "cancelado_banco",
          "cancelado_seguro",
          "cancelado_sistema",
          "cancelamento_outros",
        ] as (keyof ProposalConsignadoCustomStatus["cancelamento"])[];

        for (const key of cancelamentoKeys) {
          const item = cancelamentos[key];
          if (item?.mensagem) {
            return removeDatePrefix(item.mensagem as string);
          }
        }
      }
    } catch (error) {
      console.warn("Erro ao fazer parse do customStatus:", error, customStatus);
    }
  }


  return "Status não disponível";
}
export function getFormalizationStatusLabel(status: string): string {
  switch (status) {
    case "PROCESS_RESULT_OK":
      return "APROVADO";
    case "REPROVED":
      return "REPROVADO";
    default:
      return "PENDENTE";
  }
}
